import ReactGA from 'react-ga4';

export type ConditionsView = 'combined' | 'separate' | 'not_set' | 'unavailable';

export type FilterAction = 'set' | 'clear';

export type AnalyticsEvent =
  | {
      name: 'filter_applied';
      params: {
        filter_key: string;
        filter_type: string;
        page: string;
        action: FilterAction;
        value_count: number;
        active_filter_count: number;
      };
    }
  | { name: 'filters_reset'; params: { page: string } }
  | { name: 'chatbot_opened'; params?: never }
  | { name: 'chatbot_session_started'; params: { user_group?: string } }
  | { name: 'chatbot_message_sent'; params: { user_group?: string } }
  | { name: 'conditions_view_changed'; params: { from: ConditionsView; to: ConditionsView } };

export interface AnalyticsUserProperties {
  conditions_view: ConditionsView;
  user_group: string;
}

export const trackEvent = <E extends AnalyticsEvent>(name: E['name'], params?: E['params']) => {
  if (!ReactGA.isInitialized) return;
  ReactGA.event(name, params);
};

export const setUserProperties = (properties: Partial<AnalyticsUserProperties>) => {
  if (!ReactGA.isInitialized) return;
  ReactGA.gtag('set', 'user_properties', properties);
};

export const hashUserId = async (userId: string): Promise<string> => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(userId));
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
};
